import {ButtonProps} from "@/components/form/ButtonProps";
import {TextButton} from "@/components/form/TextButton";
import {useEffect, useState} from "react";
import {useTranslation} from 'react-i18next';

interface Props extends ButtonProps {
    countdown: number;
}

export function CountdownTextButton(props: Props) {
    const {t} = useTranslation();
    const [count, setCount] = useState(props.countdown);
    const disabled = props.disabled || count > 0;

    useEffect(() => {
        if (count > 0) {
            const timer = setTimeout(() => {
                setCount(count - 1);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [count]);

    return (
        <>
            <TextButton {...props} disabled={disabled} title={count > 0 ? `${props.title} (${count}${t('common.time.secondsAbbr')})` : props.title} />
        </>
    );
}
